import { typeGuard } from '../../../utils';
import { cacheTagTypes } from '../cacheTags/CacheTagTypes';
import { getSerializeQueryArgs } from '../getSerializeQueryArgs';
import { rpcBaseQuery } from './rpcBaseQuery';
export const createRpcApiSlice = (createRtkQueryApi) => createRtkQueryApi({
    reducerPath: typeGuard('superfluid_rpc'),
    baseQuery: rpcBaseQuery(),
    tagTypes: cacheTagTypes,
    endpoints: (_builder) => ({}),
    serializeQueryArgs: getSerializeQueryArgs(),
});
//# sourceMappingURL=rpcApiSlice.js.map